import { d as n } from "./define-BoCZvwvE.js";
const o = n(() => ({ basePrice: 0, baseCompareAtPrice: 0, currency: "SEK", locale: "sv-SE", addons: {}, optionPriceChangeHandler: null, init() {
  this.basePrice = this.toNumber(this.$el.dataset.basePrice), this.baseCompareAtPrice = this.toNumber(this.$el.dataset.baseCompareAtPrice), this.currency = this.$el.dataset.currency || "SEK", this.locale = this.$el.dataset.locale || "sv-SE", this.optionPriceChangeHandler = (t) => {
    var _a, _b;
    const e = t, r = (_a = e.detail) == null ? void 0 : _a.key, i = this.toNumber((_b = e.detail) == null ? void 0 : _b.price);
    r && (this.addons = { ...this.addons, [r]: i });
  }, window.addEventListener("product:option-price-change", this.optionPriceChangeHandler), this.requestOptionPrices();
}, destroy() {
  this.optionPriceChangeHandler && window.removeEventListener("product:option-price-change", this.optionPriceChangeHandler);
}, requestOptionPrices() {
  this.$nextTick(() => {
    window.dispatchEvent(new CustomEvent("product:price-state-request"));
  }), window.requestAnimationFrame(() => {
    window.dispatchEvent(new CustomEvent("product:price-state-request"));
  }), window.setTimeout(() => {
    window.dispatchEvent(new CustomEvent("product:price-state-request"));
  }, 100);
}, get addonsTotal() {
  return Object.values(this.addons).reduce((t, e) => t + this.toNumber(e), 0);
}, get currentPrice() {
  return this.basePrice + this.addonsTotal;
}, get currentCompareAtPrice() {
  return this.baseCompareAtPrice > this.basePrice ? this.baseCompareAtPrice + this.addonsTotal : 0;
}, get regularPriceLabel() {
  return this.formatMoney(this.currentPrice);
}, get compareAtPriceLabel() {
  return this.formatMoney(this.currentCompareAtPrice);
}, toNumber(t) {
  const e = Number(t);
  return Number.isFinite(e) ? e : 0;
}, formatMoney(t) {
  const e = t % 100 !== 0;
  return new Intl.NumberFormat(this.locale, { style: "currency", currency: this.currency, minimumFractionDigits: e ? 2 : 0, maximumFractionDigits: e ? 2 : 0 }).format(t / 100);
} }));
export {
  o as p
};
